export function scrollIntoView(e: React.MouseEvent): void {
  const href = (e.target as HTMLLinkElement).getAttribute("href");
  if (!href?.startsWith("#")) return;
  e.preventDefault();

  if ("parentIframe" in window) {
    const element = document.getElementById(href.slice(1));
    const iframeOffset = element?.getBoundingClientRect().top || 0;
    window.parentIframe.scrollToOffset(0, iframeOffset);

    return;
  }

  document
    .getElementById(href.slice(1))
    ?.scrollIntoView({ behavior: "smooth" });
}
